<div class=['evo-masonry-grid__skeleton-item', input.class] style=`aspect-ratio: ${state.aspectRatio}`/>